import { XCircleIcon } from '@heroicons/react/24/outline'
import Modal from '../common/Modal'
import { useState } from 'react'
import { handlePatchRequest } from '../../utils/api-handler.util'
import { showToaster } from '../../utils/show-toaster.util'
import { QueryKeys } from '../../utils/queryKeyGenerator'
import { useMutation } from '@tanstack/react-query'
import { VERIFICATION_STATUSES } from '../../constants/verificationStatuses'

export default function RejectShopModal({ isOpen, onClose, shopName, shopId, id }) {
  const [reason, setReason] = useState('')

  const rejectMutation = useMutation({
    mutationFn: (reason) =>
      handlePatchRequest(`admin/shop/${shopId}/review`, {
        approve: false,
        rejectReason: reason,
      }),
    onSuccess: () => {
      QueryKeys.adminShopVerificationDetails.invalidate(id)
      QueryKeys.adminListShopVerifications.invalidateAll()
      showToaster('success', 'Shop Rejected')
      onClose()
    },
    onError: () => {
      showToaster('error', 'Failed to reject shop')
    },
  })

  const handleConfirm = () => {
    rejectMutation.mutate(reason)
    setReason('')
  }

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <div className="p-2">
        <div className="mb-6">
          <h3 className="text-lg font-semibold text-gray-900">Reject Shop</h3>
        </div>

        <div>
          <div className="flex items-center gap-3 mb-4">
            <div className="w-12 h-12 bg-red-100 rounded-full flex items-center justify-center">
              <XCircleIcon className="w-6 h-6" />
            </div>
            <div>
              <h4 className="text-lg font-medium text-gray-900">Confirm Rejection</h4>
              <p className="text-sm text-gray-600">This action cannot be undone</p>
            </div>
          </div>

          <p className="text-gray-700 mb-4">
            Are you sure you want to reject the shop <strong>"{shopName}"</strong>? Please provide a
            reason for rejection below.
          </p>

          <textarea
            value={reason}
            onChange={(e) => setReason(e.target.value)}
            rows={3}
            placeholder="Enter rejection reason..."
            className="w-full border rounded p-2 text-sm"
          />
        </div>

        <div className="flex gap-3 mt-6">
          <button
            onClick={onClose}
            className="flex-1 px-4 py-2 text-gray-700 bg-background border border-gray-300 rounded-md hover:bg-neutral-200-50 transition-colors font-medium"
            disabled={rejectMutation.isLoading}
          >
            Cancel
          </button>
          <button
            onClick={handleConfirm}
            className="flex-1 px-4 py-2 bg-red-600 text-white rounded-md hover:bg-red-700 transition-colors font-medium disabled:opacity-50 disabled:cursor-not-allowed"
            disabled={!reason || rejectMutation.isLoading}
          >
            {rejectMutation.isLoading ? (
              <div className="flex items-center justify-center gap-2">
                <div className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin" />
                Rejecting...
              </div>
            ) : (
              'Reject Shop'
            )}
          </button>
        </div>
      </div>
    </Modal>
  )
}
